<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="verFilaConsultorioModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="id_medico">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Fila Atendimento
                            <span class="badge badge-dark ml-2">{{ $util.getFormatDate(referencia) }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <modulo-consultorio :ver_fila="true" :fila_ref="referencia" :id_medico_ver_fila="id_medico" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import ModuloConsultorio from './ModuloConsultorio.vue';

export default {
    data() { 
        return { 
            id_medico: null,
            referencia: null, 
        };
    },

    components: { 
        ModuloConsultorio,
    },

    methods: { 
        abrir(id_medico, referencia) { 
            this.id_medico = null;
            this.referencia = referencia;

            this.$nextTick(() => { 
                this.id_medico = id_medico;
                $('#verFilaConsultorioModal').modal('show');    
            });
        }
    }
}
</script>
